import { NgModule, Pipe, PipeTransform } from '@angular/core'
import { SharedModule } from '../shared.module'

@Pipe({
  name: 'enumtranslate',
})
export class EnumtranslatePipe implements PipeTransform {
  transform(value: string): string {
    if (value == 'NEW') {
      return 'Neu'
    } else if (value == 'USED') {
      return 'Gebraucht'
    } else if (value == 'PRIVATE') {
      return 'Privat'
    } else if (value == 'BUSINESS') {
      return 'Gewerblich'
    } else if (value == 'PICK_UP') {
      return 'Selbstabholung'
    } else if (value == 'SHIPPING') {
      return 'Versand'
    } else if (value == 'NEGOTIATING_BASIS') {
      return 'VB'
    } else if (value == 'FIXED_PRICE') {
      return 'Festpreis'
    } else if (value == 'PRICE_ON_REQUEST') {
      return 'Auf Anfrage'
    } else {
      return 'Could not be translated: ' + value
    }
  }
}

@NgModule({
  declarations: [
    EnumtranslatePipe,
  ],
  imports: [
    SharedModule,
  ],
  exports: [
    SharedModule,

    EnumtranslatePipe
  ]
})
export class EnumtranslatePipeModule { }